import {PROPERTY_SELECTOR_SIGIL} from '../constants';
/**
 * Create a function removing mapped components by component id and optionally property name
 * @function createRemoveMappings
 * @private
 *
 * @param {Object} mappings - A object that will contain mappings
 * @returns {function} - A function for removing mapped components by component id and optionally property name
 */
export default mappings =>
	function removeMappings(elementId, propertyName) {
		if (elementId && propertyName) {
			for (const key in mappings) {
				const selectorKey = mappings[key][`${elementId}${PROPERTY_SELECTOR_SIGIL}${propertyName}`];
				if (selectorKey === '' || selectorKey)
					delete mappings[key][`${elementId}${PROPERTY_SELECTOR_SIGIL}${propertyName}`]; // eslint-disable-line no-param-reassign

				if (Object.keys(mappings[key]).length === 0) delete mappings[key]; // eslint-disable-line no-param-reassign
			}
		}

		if (elementId && !propertyName) {
			for (const key in mappings) {
				for (const subKey in mappings[key]) {
					const componentId = subKey.split(PROPERTY_SELECTOR_SIGIL)[0];
					if (componentId === elementId) delete mappings[key][subKey]; // eslint-disable-line no-param-reassign
				}

				if (Object.keys(mappings[key]).length === 0) delete mappings[key]; // eslint-disable-line no-param-reassign
			}
		}
	};
